var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#CEDCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.3337 60L82.827 52.5867L83.7337 42.7734L74.107 40.5867L69.067 32.1067L60.0003 36L50.9337 32.1067L45.8937 40.5867L36.267 42.7467L37.1737 52.56L30.667 60L37.1737 67.4134L36.267 77.2534L45.8937 79.44L50.9337 87.92L60.0003 84L69.067 87.8934L74.107 79.4134L83.7337 77.2267L82.827 67.4134L89.3337 60ZM54.667 73.3334L44.0003 62.6667L47.7603 58.9067L54.667 65.7867L72.2403 48.2134L76.0003 52L54.667 73.3334Z",
    fill: "#4974D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIconCheck);
export default __webpack_public_path__ + "static/media/img-icon-check.868eb620d291c7aab9ce70f0ed316ed9.svg";
export { ForwardRef as ReactComponent };